/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_minecraft_mode_updated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identity mode updated successfully.`)
};

const zh_hans1_settings_minecraft_mode_updated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`身份模式已成功更新。`)
};

const zh_hant1_settings_minecraft_mode_updated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`身份模式已成功更新。`)
};

const fr_settings_minecraft_mode_updated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode d'identité mis à jour avec succès.`)
};

const de_settings_minecraft_mode_updated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identitätsmodus erfolgreich aktualisiert.`)
};

const ja_settings_minecraft_mode_updated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`識別モードを更新しました。`)
};

const ko_settings_minecraft_mode_updated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`신원 모드가 성공적으로 업데이트되었습니다.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_minecraft_mode_updated = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_minecraft_mode_updated(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_minecraft_mode_updated", locale)
	if (locale === "en") return en_settings_minecraft_mode_updated(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_minecraft_mode_updated(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_minecraft_mode_updated(inputs)
	if (locale === "fr") return fr_settings_minecraft_mode_updated(inputs)
	if (locale === "de") return de_settings_minecraft_mode_updated(inputs)
	if (locale === "ja") return ja_settings_minecraft_mode_updated(inputs)
	return ko_settings_minecraft_mode_updated(inputs)
};